<div class="auth-wrapper auth-v2">
    <div class="auth-inner row m-0">
        <!-- Brand logo-->
        <a class="brand-logo" href="javascript:void(0);">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="80" />
            <!-- <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" /> -->
            <!-- <h2 class="brand-text text-primary ml-1">Aranyi ERP</h2> -->
        </a>
        <!-- /Brand logo-->
        <!-- Left Text-->
        <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
            <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                <img class="img-fluid" [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/kdo_login.png'
              : 'assets/images/kdo_login.png'
          " alt="Login V2" />
            </div>
        </div>
        <!-- /Left Text-->
        <!-- Login-->
        <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
            <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h2 class="card-title font-weight-bold mb-1">
                    Üdvözöllek az KDO ERP-ben! 👋
                </h2>
                <p class="card-text mb-2">Kérlek add meg az adószámod a folytatáshoz</p>

                <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                    <div class="alert-body">
                        <p>{{ error }}</p>
                    </div>
                </ngb-alert>

                <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit(ujJelszo)">
                    <div class="form-group">
                        <label class="form-label" for="login-adoszam">Jelszó</label>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="passwordTextType ? 'text' : 'password'" formControlName="adoszam" class="form-control form-control-merge" [ngClass]="{
                  'ng-invalid.ng-touched error': submitted && f.adoszam.errors
                }" placeholder="············" aria-describedby="login-jelszo" tabindex="2" />
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
                            </div>
                        </div>
                    </div>
                    <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span
            >Bejelentkezés
          </button>

                    <div class="mt-1">
                        <a href="" [routerLink]="['/', 'bejelentkezes']">Vissza a bejelentkezéshez</a>
                    </div>
                </form>
            </div>
        </div>
        <!-- /Login-->
    </div>
</div>

<!-- Új jelszó beállítás -->
<ng-template #ujJelszo let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Új jelszó beállítása</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form class="auth-login-form mt-2" [formGroup]="jelszoForm">
            <div class="form-group">
                <label class="form-label" for="login-jelszo">Új jelszó</label>
                <div class="input-group input-group-merge form-password-toggle">
                    <input [type]="passwordTextType ? 'text' : 'password'" formControlName="jelszo" class="form-control form-control-merge" [ngClass]="{
                  'ng-invalid.ng-touched error': false
                }" placeholder="············" aria-describedby="login-jelszo" tabindex="2" />
                    <div class="input-group-append">
                        <span class="input-group-text cursor-pointer"><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label" for="login-jelszo">Jelszó mégegyszer</label>
                <div class="input-group input-group-merge form-password-toggle">
                    <input [type]="passwordTextType ? 'text' : 'password'" formControlName="jelszo_2" class="form-control form-control-merge" [ngClass]="{
                  'ng-invalid.ng-touched error': false
                }" placeholder="············" aria-describedby="login-jelszo" tabindex="2" />
                    <div class="input-group-append">
                        <span class="input-group-text cursor-pointer"><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" id="cancel-edit-btn" class="btn btn-primary" [disabled]="jelszoForm.get('jelszo').value == null || jelszoForm.get('jelszo').value !== jelszoForm.get('jelszo_2').value">Mentés</button>
        <button type="button" id="cancel-edit-btn" class="btn btn-secondary" (click)="modal.dismiss('Cross click');">Mégse</button>
    </div>
</ng-template>